<template>
  <div style="margin-left:10px">
    <vx-card class="mt-3">
      <vs-row vs-w="12" style=" margin-bottom: 10px">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12"></vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12"></vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12"></vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12"></vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12"></vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="flex-end"
          vs-lg="2"
          vs-sm="4"
          vs-xs="12"
        >
          <label for>ADV</label>
          <vs-switch v-model="advanceSearch" />
        </vs-col>
      </vs-row>
      <vs-row v-if="advanceSearch==false" vs-w="12" style=" margin-bottom: 5px">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
          <vs-button
            class="w-full"
            icon-pack="feather"
            icon="icon-plus"
            @click="popupActive2=true"
          >new Vessel</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12">
          <download-excel :data="vessels" :fields="jsonFieldsTransit" name="vessels.xls">
            <vs-button
              class="w-full"
              icon-pack="feather"
              color="primary"
            >export excel</vs-button>
          </download-excel>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12"></vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12"></vs-col>

        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
          <vs-input
            v-model="quickSearch"
            class="w-full searchCoffee m-2"
            style="border-top-right-radius: 0px; border-bottom-right-radius: 0px;"
            label-placeholder="Search"
            placeholder="Search"
            @keypress.enter="searchVessel()"
          />
          <vs-button
            class="w-1/3"
            icon-pack="feather"
            icon="icon-search"
            color="success"
            @click="searchVessel()"
          >Search</vs-button>
        </vs-col>
      </vs-row>
      <div v-if="advanceSearch==true">
        <vs-row vs-w="12" style=" margin-bottom: 5px">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <vs-input
              v-model="dataADV.mmsi"
              class="w-full"
              label-placeholder="MMSI"
              placeholder="MMSI"
              @keypress.enter="searchVessel()"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <vs-input
              v-model="dataADV.imei"
              class="w-full"
              label-placeholder="IMEI"
              placeholder="IMEI"
              @keypress.enter="searchVessel()"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <vs-input
              v-model="dataADV.imo"
              class="w-full"
              label-placeholder="IMO"
              placeholder="IMO"
              @keypress.enter="searchVessel()"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <vs-input
              v-model="dataADV.baseStationMMSI"
              class="w-full"
              label-placeholder="Base Station MMSI"
              placeholder="Base Station MMSI"
              @keypress.enter="searchVessel()"
            />
          </vs-col>

          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <vs-input
              v-model="dataADV.radioChannel"
              class="w-full"
              label-placeholder="Radio channel"
              placeholder="Radio channel"
              @keypress.enter="searchVessel()"
            />
          </vs-col>

          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <vs-input
              v-model="dataADV.name"
              class="w-full"
              label-placeholder="Name"
              placeholder="Name"
              @keypress.enter="searchVessel()"
            />
          </vs-col>
        </vs-row>
        <vs-row vs-w="12" style=" margin-bottom: 5px">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <vs-input
              v-model="dataADV.shipClass"
              class="w-full"
              label-placeholder="Ship class"
              placeholder="Ship class"
              @keypress.enter="searchVessel()"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <vs-input
              v-model="dataADV.vendor"
              class="w-full"
              label-placeholder="Vendor"
              placeholder="Vendor"
              @keypress.enter="searchVessel()"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <vs-input
              v-model="dataADV.callSing"
              class="w-full"
              label-placeholder="Call sign"
              placeholder="Call sign"
              @keypress.enter="searchVessel()"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <vs-input
              v-model="dataADV.regNumber"
              class="w-full"
              label-placeholder="Reg number"
              placeholder="Reg number"
              @keypress.enter="searchVessel()"
            />
          </vs-col>

          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <vs-input
              v-model="dataADV.description"
              class="w-full"
              label-placeholder="Description"
              placeholder="Description"
              @keypress.enter="searchVessel()"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <v-select
              id="shiptype"
              :options="cbxMid"
              v-model="dataADV.mid"
              class="w-full"
              label="name"
              label-placeholder="MID"
              placeholder="MID"
            />
          </vs-col>
        </vs-row>

        <vs-row vs-w="12" style=" margin-bottom: 5px">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <v-select
              id="shiptype"
              :options="cbxCountry"
              v-model="dataADV.country"
              class="w-full"
              label="name"
              label-placeholder="Country"
              placeholder="Country"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <v-select
              id="shiptype"
              :options="cbxShipType"
              v-model="dataADV.shipType"
              class="w-full"
              label="name"
              label-placeholder="Ship type"
              placeholder="Ship type"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          >
            <vs-button
              class="w-full"
              icon-pack="feather"
              icon="icon-search"
              color="success"
              @click="searchVessel()"
            >Search</vs-button>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          ></vs-col>

          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          ></vs-col>

          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          ></vs-col>
        </vs-row>
        <vs-row vs-w="12" style=" margin-bottom: 5px">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              class="w-full"
              icon-pack="feather"
              icon="icon-plus"
              @click="popupActive2=true"
            >new Vessel</vs-button>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          ></vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          ></vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="2"
            vs-sm="2"
            vs-xs="12"
          ></vs-col>

          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="4"
            vs-xs="12"
          ></vs-col>
        </vs-row>
      </div>
      <center>
        <vs-alert
          :active="statusLoading"
          color="primary"
          style="width:30%"
          title="Loading...."
        >กำลังโหลดข้อมูลเรือ กรุณารอสักครู่...</vs-alert>
      </center>
      <br />
      <vs-table
        :sst="true"
        :data="vessels"
        max-items="10"
        pagination
        @search="handleSearch"
        @change-page="handleChangePage"
        @sort="handleSort"
      >
        <template slot="thead">
          <vs-th sort-key="no">No.</vs-th>
          <vs-th sort-key="mmsi">MMSI</vs-th>
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="imo_number">radio channel</vs-th>
          <vs-th sort-key="imo_number">IMO</vs-th>
          <vs-th sort-key="ship_type_name">Ship type</vs-th>
          <vs-th sort-key="ship_class">Ship class</vs-th>
          <vs-th sort-key="call_sign">Call sign</vs-th>
          <vs-th sort-key="is_visible">Visible</vs-th>
          <vs-th>Edit</vs-th>
          <vs-th>Delete</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr">
            <vs-td :data="data[indextr].id">{{ tr.index+1 }}</vs-td>
            <vs-td :data="data[indextr].mmsi">{{ data[indextr].mmsi }}</vs-td>
            <vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
            <vs-td :data="data[indextr].radio_channel">{{ data[indextr].radio_channel }}</vs-td>
            <vs-td :data="data[indextr].imo_number">{{ data[indextr].imo_number }}</vs-td>
            <vs-td :data="data[indextr].ship_type_name">{{ data[indextr].ship_type_name }}</vs-td>
            <vs-td :data="data[indextr].ship_class">{{ data[indextr].ship_class }}</vs-td>
            <vs-td :data="data[indextr].call_sign">{{ data[indextr].call_sign }}</vs-td>
            <vs-td class="text-center">
              <span>
                <vs-icon :icon="tr.is_visible ? 'done' : 'close'" color="dark"></vs-icon>
              </span>
            </vs-td>
            <vs-td>
              <vs-button color="warning" @click="onEditVessel(data[indextr].mmsi)">
                <vs-icon class="align-middle" icon="edit"></vs-icon> 
                <span class="align-middle ml-2">Edit</span>
              </vs-button>
            </vs-td>
            <vs-td>
              <vs-button color="danger" @click="delectVessel(data[indextr].mmsi)">
                <vs-icon class="align-middle" icon="close"></vs-icon>
                <span class="align-middle ml-2">Delete</span>
              </vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <div class="demo-alignment">
      <!-- 
        -------------------
          NEW Vessel
        -------------------
      -->
      <vs-popup :active.sync="popupActive2" class="popup-example" title="New Vessel">
        <label for="MMSI">
          <b>MMSI</b>
        </label>
        <vs-input id="MMSI" v-model="mmis" class="w-full mb-2" />

        <label for="MID">
          <b>MID</b>
        </label>
        <vs-select id="MID" v-model="mid" class="w-full select-large">
          <vs-select-item
            v-for="(item,index) in cbxMid"
            :key="index"
            :value="item.id"
            :text="item.name"
            class="w-full mb-2"
          />
        </vs-select>

        <label for="IMO">
          <b>IMO</b>
        </label>
        <vs-input id="IMO" v-model="imo" class="w-full mb-2" />

        <label for="IMN">
          <b>IMN</b>
        </label>
        <vs-input id="IMN" v-model="imn" class="w-full mb-2" />

        <label for="Radiochannel">
          <b>Radiochannel</b>
        </label>
        <vs-input id="Radiochannel" v-model="radioChannel" class="w-full mb-2" />

        <label for="Name">
          <b>Name</b>
        </label>
        <vs-input id="Name" v-model="name" class="w-full mb-2" />

        <label for="Country">
          <b>Country</b>
        </label>
        <vs-select id="Country" v-model="country" class="w-full mb-2 select-large">
          <vs-select-item
            v-for="(item,index) in cbxCountry"
            :key="index"
            :value="item.id"
            :text="item.name"
            class="w-full"
          />
        </vs-select>

        <label for="ShipType">
          <b>ShipType</b>
        </label>
        <vs-select id="ShipType" v-model="shipType" class="w-full select-large mb-2">
          <vs-select-item
            v-for="(item,index) in cbxShipType"
            :key="index"
            :value="item.id"
            :text="item.name"
            class="w-full"
          />
        </vs-select>

        <label for="Shipclass">
          <b>Shipclass</b>
        </label>
        <vs-input id="Shipclass" v-model="shipClass" class="w-full mb-2" />

        <label for="Vendor">
          <b>Vendor</b>
        </label>
        <vs-input id="Vendor" v-model="vendor" class="w-full mb-2" />

        <label for="Callsing">
          <b>Callsing</b>
        </label>
        <vs-input id="Callsing" v-model="callSing" class="w-full mb-2" />

        <label for="Dimensiontobow">
          <b>Dimensiontobow</b>
        </label>
        <vs-input id="Dimensiontobow" v-model="dimensionToBow" class="w-full mb-2" />

        <label for="Dimensiontostern">
          <b>Dimensiontostern</b>
        </label>
        <vs-input v-model="demesionToSrern" class="w-full mb-2" />

        <label for="Length">
          <b>Length</b>
        </label>
        <vs-input id="Length" v-model="length" class="w-full mb-2" />

        <label for="Dimensiontoport">
          <b>Dimensiontoport</b>
        </label>
        <vs-input id="Dimensiontoport" v-model="dimensionToPort" class="w-full mb-2" />

        <label for="Dimensiontostarboard">
          <b>Dimensiontostarboard</b>
        </label>
        <vs-input id="Dimensiontostarboard" v-model="dimensionToStarboard" class="w-full mb-2" />

        <label for="Beam">
          <b>Beam</b>
        </label>
        <vs-input id="Beam" v-model="beam" class="w-full mb-2" />

        <label for="Positionreport">
          <b>Positionreport</b>
        </label>
        <vs-input id="Positionreport" v-model="positionReport" class="w-full mb-2" />

        <label for="Nettonnage">
          <b>Nettonnage</b>
        </label>
        <vs-input id="Nettonnage" v-model="netTonnage" class="w-full mb-2" />

        <label for="Regnumber">
          <b>Regnumber</b>
        </label>
        <vs-input id="Regnumber" v-model="regNumber" class="w-full mb-2" />

        <label for="Color">
          <b>Color</b>
        </label>
        <vs-input id="Color" v-model="color" class="w-full mb-2" />

        <label for="Description">
          <b>Description</b>
        </label>
        <vs-input id="Description" v-model="description" class="w-full mb-2" />

        <label for="Othercomch">
          <b>Othercomch</b>
        </label>
        <vs-input id="Othercomch" v-model="otherComCh" class="w-full mb-2" />

        <label for="Ownername">
          <b>Ownername</b>
        </label>
        <vs-input id="Ownername" v-model="ownerName" class="w-full mb-2" />

        <label for="Owneraddress">
          <b>Owneraddress</b>
        </label>
        <vs-input id="Owneraddress" v-model="ownerAddress" class="w-full mb-2" />

        <label for="Ownerphone">
          <b>Ownerphone</b>
        </label>
        <vs-input id="Ownerphone" v-model="ownerPhone" class="w-full mb-2" />

        <!----------------------->
        <label for="Mastername">
          <b>Mastername</b>
        </label>
        <vs-input id="Mastername" v-model="masterName" class="w-full mb-2" />

        <label for="Masteraddress">
          <b>Masteraddress</b>
        </label>
        <vs-input id="Masteraddress" v-model="masterAddress" class="w-full mb-2" />

        <label for="Masterphone">
          <b>Masterphone</b>
        </label>
        <vs-input id="Masterphone" v-model="masterPhone" class="w-full mb-2" />

        <ul class="con-s">
          <li>
            <label for>Visible</label>
            <vs-switch v-model="visible" />
          </li>
        </ul>

        <!-- <vs-upload
          action="https://jsonplaceholder.typicode.com/posts/"
          @on-success="successUpload"
        /> -->
        <div style="margin-top:8;">
          <vs-button color="primary" class="w-full" type="filled" @click="setVessel(1)">Save</vs-button>
        </div>
      </vs-popup>
      <!-- 
        -------------------
          Edit Vessel
        -------------------
      -->
      <vs-popup :active.sync="popupActive3" classContent="popup-example" title="Edit Vessel ">
        <!----------------------->
        <label for="MMSI">
          <b>MMSI</b>
        </label>
        <vs-input id="MMSI" v-model="mmis" class="w-full mb-2" />

        <!----------------------->
        <label for="MID">
          <b>MID</b>
        </label>
        <vs-select id="MID" v-model="mid" class="w-full select-large mb-2">
          <vs-select-item
            v-for="(item,index) in cbxMid"
            :key="index"
            :value="item.id"
            :text="item.name"
            class="w-full"
          />
        </vs-select>
        <!----------------------->
        <label for="IMO">
          <b>IMO</b>
        </label>
        <vs-input id="IMO" v-model="imo" class="w-full mb-2" />
        <!----------------------->
        <label for="IMN">
          <b>IMN</b>
        </label>
        <vs-input id="IMN" v-model="imn" class="w-full mb-2" />
        <!----------------------->
        <label for="Radiochannel">
          <b>Radio channel</b>
        </label>
        <vs-input id="Radiochannel" v-model="radioChannel" class="w-full mb-2" />
        <!----------------------->
        <label for="name">
          <b>Name</b>
        </label>
        <vs-input id="name" v-model="name" class="w-full mb-2" />
        <!----------------------->
        <label for="Country">
          <b>Country</b>
        </label>
        <vs-select id="Country" v-model="country" class="w-full select-large mb-2">
          <vs-select-item
            v-for="(item,index) in cbxCountry"
            :key="index"
            :value="item.id"
            :text="item.name"
            class="w-full"
          />
        </vs-select>
        <!----------------------->
        <label for="ShipType">
          <b>ShipType</b>
        </label>
        <vs-select id="ShipType" v-model="shipType" class="w-full mb-2 select-large">
          <vs-select-item
            v-for="(item,index) in cbxShipType"
            :key="index"
            :value="item.id"
            :text="item.name"
            class="w-full"
          />
        </vs-select>
        <!----------------------->
        <label for="Shipclass">
          <b>Ship class</b>
        </label>
        <vs-input id="Shipclass" v-model="shipClass" class="w-full mb-2" />
        <!----------------------->
        <label for="Vendor">
          <b>Vendor</b>
        </label>
        <vs-input id="Vendor" v-model="vendor" class="w-full mb-2" />
        <!----------------------->
        <label for="Callsing">
          <b>Call sing</b>
        </label>
        <vs-input id="Callsing" v-model="callSing" class="w-full mb-2" />
        <!----------------------->
        <label for="Dimensiontobow">
          <b>Dimension to bow</b>
        </label>
        <vs-input id="Dimensiontobow" v-model="dimensionToBow" class="w-full mb-2" />
        <!----------------------->
        <label for="Dimensiontostern">
          <b>Dimension to stern</b>
        </label>
        <vs-input id="Dimensiontostern" v-model="demesionToSrern" class="w-full mb-2" />
        <!----------------------->
        <label for="Length">
          <b>Length</b>
        </label>
        <vs-input id="Length" v-model="length" class="w-full mb-2" />
        <!----------------------->
        <label for="Dimensiontoport">
          <b>Dimension to port</b>
        </label>
        <vs-input id="Dimensiontoport" v-model="dimensionToPort" class="w-full mb-2" />
        <!----------------------->
        <label for="imensiontostarboard">
          <b>Dimension to starboard</b>
        </label>
        <vs-input id="imensiontostarboard" v-model="dimensionToStarboard" class="w-full mb-2" />
        <!----------------------->
        <label for="Beam">
          <b>Beam</b>
        </label>
        <vs-input id="Beam" v-model="beam" class="w-full mb-2" />
        <!----------------------->
        <label for="positionReport">
          <b>Position Report</b>
        </label>
        <vs-input id="positionReport" v-model="positionReport" class="w-full mb-2" />
        <!----------------------->
        <label for="netTonnage">
          <b>Net tonnage</b>
        </label>
        <vs-input id="netTonnage" v-model="netTonnage" class="w-full mb-2" />
        <!----------------------->
        <label for="regNumber">
          <b>Reg Number</b>
        </label>
        <vs-input id="regNumber" v-model="regNumber" class="w-full mb-2" />
        <!----------------------->
        <label for="color">
          <b>Color</b>
        </label>
        <vs-input id="color" v-model="color" class="w-full mb-2" />
        <!----------------------->
        <label for="description">
          <b>Description</b>
        </label>
        <vs-input id="description" v-model="description" class="w-full mb-2" />
        <!----------------------->
        <label for="otherComCh">
          <b>Other Com Ch</b>
        </label>
        <vs-input id="otherComCh" v-model="otherComCh" class="w-full mb-2" />
        <!----------------------->
        <label for="Ownername">
          <b>Owner name</b>
        </label>
        <vs-input id="Ownername" v-model="ownerName" class="w-full mb-2" />
        <!----------------------->
        <label for="ownerAddress">
          <b>Owner address</b>
        </label>
        <vs-input id="ownerAddress" v-model="ownerAddress" class="w-full mb-2" />
        <!----------------------->
        <label for="ownerPhone">
          <b>Owner phone</b>
        </label>
        <vs-input id="ownerPhone" v-model="ownerPhone" class="w-full mb-2" />
        <!----------------------->
        <label for="masterName">
          <b>Master name</b>
        </label>
        <vs-input id="masterName" v-model="masterName" class="w-full mb-2" />
        <!----------------------->
        <label for="Masteraddress">
          <b>Master address</b>
        </label>
        <vs-input id="Masteraddress" v-model="masterAddress" class="w-full mb-2" />
        <label for="masterPhone">
          <b>Master phone</b>
        </label>
        <vs-input id="masterPhone" v-model="masterPhone" class="w-full mb-2" />
        <ul class="con-s">
          <li>
            <label for>Visible</label>
            <vs-switch v-model="visible" />
          </li>
        </ul>
        <!-- <vs-upload
          action="https://jsonplaceholder.typicode.com/posts/"
          @on-success="successUpload"
        /> -->
        <div style="margin-top:8;">
          <vs-button color="primary" class="w-full" type="filled" @click="setVessel(2)">Save</vs-button>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import downloadExcel from "vue-json-excel";
import { API_BASE_URL } from '@/constants'

export default {
  components: {
    vSelect,
    downloadExcel
  },
  data() {
    return {
      jsonFieldsTransit: {
        No: {
          field: "index",
          callback: (value) => {
            return `${value + 1}`;
          },
        },
        MMSI: "mmsi",
        Name: "name",
        "Radio channel": "radio_channel",
        imo: "imo_number",
        "Ship type": "ship_type",
        "Ship class": "ship_class",
        "Call sign": "call_sign",
        visible: "is_visible"
      },
      statusLoading: false,
      numberList: 0,
      dataADV: {
        mmsi: "",
        imei: "",
        imo: "",
        imn: "",
        radioChannel: "",
        name: "",
        shipClass: "",
        vendor: "",
        callSing: "",
        regNumber: "",
        color: "",
        description: "",
        otherComCh: "",
        ownerName: "",
        ownerAddress: "",
        ownerPhone: "",
        masterName: "",
        masterAddress: "",
        masterPhone: "",
        baseStationMMSI: "",
        mid: {},
        country: {},
        shipType: {}
      },
      advanceSearch: false,
      quickSearch: "",
      value2: "",
      mmis: "",
      mid: "",
      name: "",
      country: "",
      imo: "",
      imn: "",
      radioChannel: "",
      shipType: "",
      shipClass: "",
      vendor: "",
      callSing: "",
      dimensionToBow: "",
      demesionToSrern: "",
      length: "",
      dimensionToPort: "",
      dimensionToStarboard: "",
      beam: "",
      positionReport: "",
      netTonnage: "",
      regNumber: "",
      color: "",
      description: "",
      otherComCh: "",
      ownerName: "",
      ownerAddress: "",
      ownerPhone: "",
      masterName: "",
      masterAddress: "",
      masterPhone: "",
      value3: "",
      visible: null,
      //--------
      popupActive2: false,
      popupActive3: false,
      vessels: [],
      selected: {},
      btnStatus: false,

      statusUpdate: false,
      postDataVessle: {},
      cbxMid: [],
      cbxShipType: [],
      cbxCountry: [],
      key: "",
      activeLoading: false,
      accessEmail: "",
      accessToken: "",
      visibleStatus: 0
    };
  },
  mounted() {
    // this.$vs.loading();
    (this.statusLoading = true),
      (this.accessEmail = localStorage.getItem("accessEmail"));
    this.accessToken = localStorage.getItem("accessToken");
    this.$store.dispatch("updateTitlePage", "Vessels");

    axios
      .get(`${API_BASE_URL}/admin/vessels.json`, {
        params: {
          limit: 50,
          "q[is_visible_true]": 1
        },
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken
        }
      })

      .then(response => {
        this.vessels = response.data;
        // this.$vs.loading.close();
        this.statusLoading = false;
      })
      .catch(error => {
        console.log("API vessels  error:", error);
      });

    axios
      .get(`${API_BASE_URL}/admin/mids.json`, {
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken
        }
      })
      .then(response => {
        this.cbxMid = response.data;
      })
      .catch(error => {
        console.log("API error:", error);
      });
    axios
      .get(`${API_BASE_URL}/admin/ship_types.json`, {
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken
        }
      })
      .then(response => {
        this.cbxShipType = response.data;
      })
      .catch(error => {
        console.log("Error call apis :", error);
      });
    //get conty
    axios
      .get(`${API_BASE_URL}/shared/countries.json`, {
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken
        }
      })
      .then(response => {
        this.cbxCountry = response.data;
      })
      .catch(error => {
        console.log("Error call apis :", error);
      });
  },
  methods: {
    searchVessel() {
      // this.$vs.loading();
      this.statusLoading = true;
      if (this.advanceSearch == false) {
        if (this.quickSearch == "") {
          axios
            .get(`${API_BASE_URL}/admin/vessels.json`, {
              params: {
                utf8: "✓",
                "q[mmsi_or_imei_or_imo_number_or_imn_number_or_radio_channel_or_name_or_ship_class_or_vendor_id_or_call_sign_or_reg_number_or_color_or_description_or_other_com_ch_or_owner_name_or_owner_address_or_owner_phone_or_master_name_or_master_address_or_master_phone_cont]": this
                  .quickSearch,
                limit: 50
              },
              headers: {
                "X-User-Email": this.accessEmail,
                "X-User-Token": this.accessToken
              }
            })

            .then(response => {
              this.vessels = response.data;
              // this.$vs.loading.close();
              this.statusLoading = false;
            })
            .catch(error => {
              console.log("API vessels  error:", error);
            });
        } else {
          axios
            .get(`${API_BASE_URL}/admin/vessels.json`, {
              params: {
                utf8: "✓",
                "q[mmsi_or_imei_or_imo_number_or_imn_number_or_radio_channel_or_name_or_ship_class_or_vendor_id_or_call_sign_or_reg_number_or_color_or_description_or_other_com_ch_or_owner_name_or_owner_address_or_owner_phone_or_master_name_or_master_address_or_master_phone_cont]": this
                  .quickSearch
              },
              headers: {
                "X-User-Email": this.accessEmail,
                "X-User-Token": this.accessToken
              }
            })

            .then(response => {
              this.vessels = response.data;
              // this.$vs.loading.close();
              this.statusLoading = false;
            })
            .catch(error => {
              console.log("API vessels  error:", error);
            });
        }
      } else {
        if (this.dataADV.mid == null) {
          this.dataADV.mid = {
            id: ""
          };
        } else if (this.dataADV.country == null) {
          this.dataADV.country = {
            id: ""
          };
        } else if (this.dataADV.shipType == null) {
          this.dataADV.shipType = {
            id: ""
          };
        }
        axios
          .get(`${API_BASE_URL}/admin/vessels.json`, {
            params: {
              utf8: "✓",
              "q[mmsi_cont]": this.dataADV.mmsi,
              "q[imei_cont]": this.dataADV.imei,
              "q[imo_number_cont]": this.dataADV.imo,
              "q[imn_number_cont]": this.dataADV.imn,
              "q[radio_channel_cont]": this.dataADV.radioChannel,
              "q[name_cont]": this.dataADV.name,
              "q[ship_class_cont]": this.dataADV.shipClass,
              "q[vendor_id_cont]": this.dataADV.vendor,
              "q[call_sign_cont]": this.dataADV.callSing,
              "q[reg_number_cont]": this.dataADV.regNumber,
              "q[color_cont]": this.dataADV.color,
              "q[description_cont]": this.dataADV.description,
              "q[other_com_ch_cont]": this.dataADV.otherComCh,
              "q[owner_name_cont]": this.dataADV.ownerName,
              "q[owner_address_cont]": this.dataADV.ownerAddress,
              "q[owner_phone_cont]": this.dataADV.ownerPhone,
              "q[master_name_cont]": this.dataADV.masterName,
              "q[master_address_cont]": this.dataADV.masterAddress,
              "q[master_phone_cont]": this.dataADV.masterPhone,
              "q[base_station_mmsi_cont]": this.dataADV.baseStationMMSI,
              "q[mid_id_eq]": this.dataADV.mid.id,
              "q[country_id_eq]": this.dataADV.country.id,
              "q[ship_type_id_eq]": this.dataADV.shipType.id
            },
            headers: {
              "X-User-Email": this.accessEmail,
              "X-User-Token": this.accessToken
            }
          })

          .then(response => {
            this.vessels = response.data;
            // this.$vs.loading.close();
            this.statusLoading = false;
          })
          .catch(error => {
            // this.$vs.loading.close();
            this.statusLoading = false;
            console.log("API vessels  error:", error);
          });
      }
    },
    handleSearch(searching) {
      let _print = `The user searched for: ${searching}\n`;
      this.$refs.pre.appendChild(document.createTextNode(_print));
    },
    handleChangePage(page) {
      let _print = `The user changed the page to: ${page}\n`;
      this.$refs.pre.appendChild(document.createTextNode(_print));
    },
    handleSort(key, active) {
      let _print = `the user ordered: ${key} ${active}\n`;
      this.$refs.pre.appendChild(document.createTextNode(_print));
    },
    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Lorem ipsum dolor sit amet, consectetur"
      });
    },
    setVessel(sta) {
      this.activeLoading = true;
      console.log("sta : " + sta);
      // sta 1 add , sta 2 edit
      this.postDataVessle = {
        sta: sta,
        id: this.key,
        mmsi: this.mmis,
        mid: this.mid,
        mid_id: this.mid,
        imo_number: this.imo,
        imn_number: this.imn,
        radio_channel: this.radioChannel,
        name: this.name,
        country: this.country,
        country_id: this.country,
        ship_type_id: this.shipType,
        ship_class: this.shipClass,
        vendor_id: this.vendor,
        call_sign: this.callSing,
        dimension_to_bow: this.dimensionToBow,
        dimension_to_stern: this.demesionToSrern,
        length: this.length,
        dimension_to_port: this.dimensionToPort,
        dimension_to_starboard: this.dimensionToStarboard,
        beam: this.beam,
        position_report_id: this.positionReport,
        net_tonnage: this.netTonnage,
        reg_number: this.regNumber,
        color: this.color,
        description: this.description,
        other_com_ch: this.otherComCh,
        owner_name: this.ownerName,
        owner_address: this.ownerAddress,
        owner_phone: this.ownerPhone,
        master_name: this.masterName,
        master_address: this.masterAddress,
        master_phone: this.masterPhone,
        is_visible: this.visibleStatus
      };
    },
    saveVessel() {
      //console.log(this.postDataVessle)
      axios
        .post(
          `${API_BASE_URL}/admin/vessels.json`,
          this.postDataVessle,
          {
            headers: {
              "X-User-Email": this.accessEmail,
              "X-User-Token": this.accessToken,
              "Content-Type": "application/json"
            }
          }
        )
        .then(response => {
          console.log(" GetSuccess : ", response.data);
          // this.vessels = response.data
          this.vessels.unshift(response.data);
          this.statusUpdate = true;
          this.popupActive2 = false;
          this.activeLoading = false;
        })
        .catch(error => {
          console.log(" error:", error);
          this.popupActive2 = false;
          this.activeLoading = false;
          console.log(JSON.stringify(this.postDataVessle));
        });
    },
    editVessel() {
      let indexOfVessels = this.vessels.indexOf(this.selected);
      //console.log("indexOfVessels : "+ indexOfVessels)
      axios
        .put(
          `${API_BASE_URL}/admin/vessels/` + this.key + ".json",
          this.postDataVessle,
          {
            headers: {
              "X-User-Email": this.accessEmail,
              "X-User-Token": this.accessToken,
              "Content-Type": "application/json"
            }
          }
        )
        .then(response => {
          console.log(" success:");
          // this.vessels = response.data

          this.vessels.splice(indexOfVessels, 1, this.postDataVessle);

          // this.statusUpdate = true
          this.activeLoading = false;
          this.popupActive3 = false;
        })
        .catch(error => {
          console.log(" error:", error);
        });
    },
    onEditVessel(mmsi) {
      this.selected = this.vessels.find(vessel => vessel.mmsi == mmsi)
      if (this.selected) {
        this.popupActive3 = true
      } else { 
        alert("ระบบขัดข้องโปรลองใหม่อีกครั้ง")
      }
    },
    delectVessel(mmsi) {
      this.selected = this.vessels.find(vessel => vessel.mmsi == mmsi)
      if (this.selected) {
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: `Confirm`,
          text:
            `ต้องการลบข้อมูลเรือ ${this.selected.name}`,
          accept: this.acceptAlert
        });
      } else {
        alert("ระบบขัดข้องโปรลองใหม่อีกครั้ง")
      }
    },
    acceptAlert() {
      this.activeLoading = true;
      let indexOfVessels = this.vessels.indexOf(this.selected);
      axios
        .delete(
          `${API_BASE_URL}/admin/vessels/` + this.key + ".json",
          {
            headers: {
              "X-User-Email": this.accessEmail,
              "X-User-Token": this.accessToken,
              "Content-Type": "application/json"
            }
          }
        )
        .then(response => {
          this.vessels.splice(indexOfVessels, 1);
          this.$vs.notify({
            color: "danger",
            title: "Deleted vessel",
            text: "The selected vessel was successfully deleted"
          });
          this.statusUpdate = true;

          // this.popupActive3 = false
        })
        .catch(error => {
          console.log(" error:", error);
        });
    },
    clearDataInput() {
      this.mmis = null;
      this.mid = null;
      this.imo = null;
      this.imn = null;
      this.radioChannel = null;
      this.name = null;
      this.country = null;
      this.shipType = null;
      this.shipClass = null;
      this.vendor = null;
      this.callSing = null;
      this.dimensionToBow = null;
      this.demesionToSrern = null;
      this.length = null;
      this.dimensionToPort = null;
      this.dimensionToStarboard = null;
      this.beam = null;
      this.positionReport = null;
      this.netTonnage = null;
      this.regNumber = null;
      this.color = null;
      this.description = null;
      this.otherComCh = null;
      this.ownerName = null;
      this.ownerAddress = null;
      this.ownerPhone = null;
      this.masterName = null;
      this.masterAddress = null;
      this.masterPhone = null;
      this.statusUpdate = false;
      (this.visible = null), (this.visibleStatus = 0), (this.key = "");
      this.selected = {};
    },
    openLoading() {
      console.log("openLoad");
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        this.visibleStatus = 1;
      } else {
        this.visibleStatus = 0;
      }
    },
    vessels() {
      for (let i = 0; i < this.vessels.length; i++) {
        this.vessels[i].index = i;
      }
    },
    postDataVessle() {
      console.log("2) sta : " + this.postDataVessle.sta);
      if (this.postDataVessle.sta == 1) {
        delete this.postDataVessle.sta;
        this.saveVessel();
      } else if (this.postDataVessle.sta == 2) {
        delete this.postDataVessle.sta;
        this.editVessel();
      }
      //
    },
    statusUpdate() {
      console.log("clear");
      this.activeLoading = false;
      this.clearDataInput();
    },
    popupActive2() {
      this.clearDataInput();
    },
    popupActive3() {
      // this.clearDataInput()
      console.log("popup3");
    },
    selected() {
      this.btnStatus = true;
      this.key = this.selected.id;
      this.mmis = this.selected.mmsi;
      this.mid = this.selected.mid_id;
      this.imo = this.selected.imo_number;
      this.imn = this.selected.imn_number;
      this.radioChannel = this.selected.radio_channel;
      this.name = this.selected.name;
      this.country = this.selected.country_id;
      this.shipType = this.selected.ship_type_id;
      this.shipClass = this.selected.ship_class;
      this.vendor = this.selected.vendor_id;
      this.callSing = this.selected.call_sign;
      this.dimensionToBow = this.selected.dimension_to_bow;
      this.demesionToSrern = this.selected.dimension_to_stern;
      this.length = this.selected.length;
      this.dimensionToPort = this.selected.dimension_to_port;
      this.dimensionToStarboard = this.selected.dimension_to_starboard;
      this.beam = this.selected.beam;
      this.positionReport = this.selected.position_report_id;
      this.netTonnage = this.selected.net_tonnage;
      this.reg_number = this.selected.reg_number;
      this.color = this.selected.color;
      this.description = this.selected.description;
      this.otherComCh = this.selected.other_com_ch;
      this.ownerName = this.selected.owner_name;
      this.ownerAddress = this.selected.owner_address;
      this.ownerPhone = this.selected.owner_phone;
      this.masterName = this.selected.master_name;
      this.masterAddress = this.selected.master_address;
      this.master_phone = this.selected.master_phone;
      this.visible = this.selected.is_visible;
    },
    activeLoading() {
      if (this.activeLoading == true) {
        // this.$vs.loading({
        //   type: "radius"
        // });
        this.statusLoading = true;
      } else if (this.activeLoading == false) {
        // this.$vs.loading.close();
        this.statusLoading = false;
      }
    }
  }
};
</script>


<style>
.vs-con-input-label.is-label-placeholder {
  margin-top: 0px;
}
.searchCoffee {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.vs-butt-search {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.con-vs-popup .vs-popup {
  width: 1000px;
}
</style>